/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Gallery } from 'react-grid-gallery';
import { getFileExtension } from 'services/utils/files';
import { useLocation } from 'react-router';
import { domain } from 'services/utils/const';
import useLightbox from 'hooks/useLightbox';
import Data from './Data';

const StyledImg = styled.img`
  width: 150px;
  height: 150px;
  cursor: pointer;
`;

const Images = ({ order }) => {
  const location = useLocation();
  const [images, setImages] = useState([]);
  const [pdf, setPdf] = useState([]);

  const { openImage, lightbox } = useLightbox(images);

  useEffect(() => {
    let imgs = [],
      pdfs = [];
    //  get custom milling image
    getImages(
      order.customMilling?.path,
      'Rodzaj frezowania',
      (image) => imgs.push(image),
      (newPdf) => pdfs.push(newPdf),
      domain,
    );
    getImages(
      order.customPilaster?.path,
      'Pilaster',
      (image) => imgs.push(image),
      (newPdf) => pdfs.push(newPdf),
      domain,
    );
    getImages(
      order.customCrown?.path,
      'Korona',
      (image) => imgs.push(image),
      (newPdf) => pdfs.push(newPdf),
      domain,
    );

    // get elements images
    order.items.forEach((item, index) => {
      getImages(
        item.image?.path,
        `Rysunek do  elementu z pozycji nr: ${index + 1}`,
        (image) => imgs.push(image),
        (newPdf) => pdfs.push(newPdf),
        domain,
      );
    });
    order.customItems.forEach((item, index) => {
      getImages(
        item.image?.path,
        `Rysunek do  elementu niestandardowego z pozycji nr: ${index + 1}`,
        (image) => imgs.push(image),
        (newPdf) => pdfs.push(newPdf),
        domain,
      );
    });
    setImages(imgs);
    setPdf(pdfs);
  }, [order]);
  console.log(images);
  return (
    <div>
      {location.pathname.includes('summary') &&
      (images.length > 0 || pdf.length > 0) ? (
        <h5>
          Wszystkie zdjęcia zostaną wyświetlone po złożeniu zamówienia
        </h5>
      ) : (
        <>
          <Gallery images={images} onClick={openImage} margin={5} />
          {pdf.length > 0 &&
            pdf.map((item) => {
              return (
                <span key={item.src}>
                  <a href={`${domain}${item.src}`}>
                    <StyledImg
                      src={require(`assets/images/pdf-icon.png`)}
                      alt="Rysunek"
                      title={item.title}
                    />
                  </a>
                </span>
              );
            })}
        </>
      )}
      {lightbox}
    </div>
  );
};

export default Images;

const getImages = (path, caption, setImages, setPdf, domain) => {
  if (path) {
    const ext = getFileExtension(path);
    if (ext !== 'pdf') {
      const image = createImage(path, caption, domain);

      setImages(image);
    } else {
      const newPdf = {
        src: path,
        title: caption,
      };
      setPdf(newPdf);
    }
  }
};

const createImage = (path, caption, domain) => ({
  src: `${domain}${path}?${new Date().getTime()}`,
  thumbnail: path,
  thumbnailWidth: 150,
  width: 150,
  thumbnailHeight: 150,
  height: 150,
  caption: caption,
  alt: 'Problem z wyświetleniem zdjęcia',
  isSelected: false,
});
